import React, { useContext, useEffect } from "react";

import { MessageServiceOption, MessageContext } from "./provider";

let messageContext: (options: MessageServiceOption) => void;

export const UseMessage: React.FC = () => {
  const useMessage = useContext(MessageContext);

  if (useMessage === undefined) {
    throw new Error("useMessage must be used within MessageContext");
  }

  useEffect(() => {
    messageContext = useMessage;
  }, [useMessage]);

  return null;
};

export const message = (options: MessageServiceOption) =>
  messageContext(options);
